import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import VenderProfile from "./venderprofile";
import Footer from "./Footer";
const VenderProfileSetting = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <VenderProfile />
      <Footer />
    </>
  );
};

export default VenderProfileSetting;
